// ---------------------------------------------------------------------------------------------------------
// Stats From Player
// ---------------------------------------------------------------------------------------------------------

export const gamesPlayedFromPlayer = (player: any) => {
    return (gamesPlayedFromStats(player.stats));
};

export const goalsFromPlayer = (player: any) => {
    return (goalsFromStats(player.stats));
};

export const assistsFromPlayer = (player: any) => {
    return (assistsFromStats(player.stats));
};

export const shotsFromPlayer = (player: any) => {
    return (shotsFromStats(player.stats));
};

export const blocksFromPlayer = (player: any) => {
    return (blocksFromStats(player.stats));
};

export const groundBallsFromPlayer = (player: any) => {
    return (groundBallsFromStats(player.stats));
};

export const turnOversFromPlayer = (player: any) => {
    return (turnOversFromStats(player.stats));
};

export const penaltiesFromPlayer = (player: any) => {
    return (penaltiesFromStats(player.stats));
};

export const penaltyMinutesFromPlayer = (player: any) => {
    return (penaltyMinutesFromStats(player.stats));
};

export const goalsConcededFromPlayer = (player: any) => {
    return (goalsConcededFromStats(player.stats));
};

export const shotsSavedFromPlayer = (player: any) => {
    return (shotsSavedFromStats(player.stats));
};

export const goalieShotsOnGoalFromPlayer = (player: any) => {
    return goalieShotsOnGoalFromStats(player.stats);
};

export const goalieMinutesFromPlayer = (player: any) => {
    return goalieMinutesFromStats(player.stats);
};

// ---------------------------------------------------------------------------------------------------------
// Stats From Stats
// ---------------------------------------------------------------------------------------------------------

export const gamesPlayedFromStats = (stats: any[]) => {
    let total = 0;
    stats.forEach((stat: any) => {
        total += stat.gamesPlayed;
    });
    return total;
};

export const winsFromStats = (stats: any[]) => {
    let total = 0;
    stats.forEach((stat: any) => {
        total += stat.wins;
    });
    return total;
};

export const goalsFromStats = (stats: any[]) => {
    let total = 0;
    stats.forEach((stat: any) => {
        total += stat.goals;
    });
    return total;
};

export const assistsFromStats = (stats: any[]) => {
    let total = 0;
    stats.forEach((stat: any) => {
        total += stat.assists;
    });
    return total;
};

export const shotsFromStats = (stats: any[]) => {
    let total = 0;
    stats.forEach((stat: any) => {
        total += stat.shots;
    });
    return total;
};

export const blocksFromStats = (stats: any[]) => {
    let total = 0;
    stats.forEach((stat: any) => {
        total += stat.blocks;
    });
    return total;
};

export const turnOversFromStats = (stats: any[]) => {
    let total = 0;
    stats.forEach((stat: any) => {
        total += stat.turnOvers;
    });
    return total;
};

export const groundBallsFromStats = (stats: any[]) => {
    let total = 0;
    stats.forEach((stat: any) => {
        total += stat.groundBalls;
    });
    return total;
};

export const penaltiesFromStats = (stats: any[]) => {
    let total = 0;
    stats.forEach((stat: any) => {
        total += stat.penalties;
    });
    return total;
};

export const penaltyMinutesFromStats = (stats: any[]) => {
    let total = 0;
    stats.forEach((stat: any) => {
        total += stat.penaltyMinutes;
    });
    return total;
};

export const goalsConcededFromStats = (stats: any[]) => {
    let total = 0;
    stats.forEach((stat: any) => {
        total += stat.goalieGoalsConceded;
    });
    return total;
};

export const shotsSavedFromStats = (stats: any[]) => {
    let total = 0;
    stats.forEach((stat: any) => {
        total += stat.goalieShotsSaved;
    });
    return total;
};

export const goalieShotsOnGoalFromStats = (stats: any[]) => {
    let total = 0;
    stats.forEach((stat: any) => {
        total += stat.goalieShotsOnGoal;
    });
    return total;
};

export const goalieMinutesFromStats = (stats: any[]) => {
    let total = 0;
    stats.forEach((stat: any) => {
        total += stat.goalieMinutes;
    });
    return total;
};

// ---------------------------------------------------------------------------------------------------------
// Specific Stats From Player
// ---------------------------------------------------------------------------------------------------------

export const pointsFromPlayer = (player: any) => {
    return goalsFromPlayer(player) + assistsFromPlayer(player);
};

export const goalsPerShotsFromPlayer = (player: any) => {
    return (goalsFromPlayer(player) / shotsFromPlayer(player)).toFixed(2);
};

export const goalsConcededPerGameFromPlayer = (player: any) => {
    return (goalsConcededFromPlayer(player) / gamesPlayedFromPlayer(player)).toFixed(2);
};

export const savesPerShotsOnGoalFromPlayer = (player: any) => {
    return (shotsSavedFromPlayer(player) / goalieShotsOnGoalFromPlayer(player)).toFixed(2);
};

// ---------------------------------------------------------------------------------------------------------
// Specific Stats From Player Stats
// ---------------------------------------------------------------------------------------------------------

export const pointsFromStats = (stats: any[]) => {
    return goalsFromStats(stats) + assistsFromStats(stats);
};

export const goalsPerShotsFromStats = (stats: any[]) => {
    return (goalsFromStats(stats) / shotsFromStats(stats)).toFixed(2);
};

export const goalsConcededPerGameFromStats = (stats: any[]) => {
    return (goalsConcededFromStats(stats) / gamesPlayedFromStats(stats)).toFixed(2);
};

export const savesPerShotsOnGoalFromStats = (stats: any[]) => {
    return (shotsSavedFromStats(stats) / goalieShotsOnGoalFromStats(stats)).toFixed(2);
};

// ---------------------------------------------------------------------------------------------------------
// Specific Stats
// ---------------------------------------------------------------------------------------------------------

export const pointsFromGoalsAndAssists = (goals: number, assists: number) => {
    return goals + assists;
};

export const goalsPerShotsFromGoalsAndShots = (goals: number, shots: number) => {
    return ((100 * goals) / shots).toFixed(2);
};

export const goalsConcededPerGameFromGoalsConcededAndGames = (goalsConceded: number, games: number) => {
    return (goalsConceded / games).toFixed(2);
};

export const shootingPercentagesFromShotsSavesAndShotsOnGoal = (shotsSaved: number, shotsOnGoal: number) => {
    return (shotsSaved / shotsOnGoal).toFixed(2);
};
